{
  "integrations-plaid": "Plaid",
  "integrations-baa": "ByAllAccounts",
  "integrations-linked-account-tooltip-connected": "connected",
  "integrations-linked-account-tooltip-disconnected": "disconnected",

  "integrations-page-heading": "Integrations",
  "integrations-page-meta-title": "Elements Third Party Integrations",
  "integrations-page-meta-description": "Check out our third party integrations!",
  "integrations-page-eyebrow": "Advisor integration lab",
  "integrations-page-description": "Vote on the advisor tools you want Elements to connect with next, and tell us what is missing from the list.",
  "integrations-page-count-label": "Integrations",
  "integrations-page-votes-label": "Your votes",
  "integrations-voting-section-label": "Integration voting options",
  "integrations-status-candidate": "Candidate",
  "integrations-status-live": "Live today",
  "integrations-status-popular": "Popular request",
  "integrations-card-vote": "Vote",
  "integrations-card-vote-aria": "Vote for {{name}}",
  "integrations-card-voted": "Voted",
  "integrations-card-voted-aria": "Voted for {{name}}",
  "integrations-card-view-details": "View details",
  "integrations-opens-new-tab": " opens in a new tab",
  "integrations-vote-thanks": "Thanks for voting.",
  "integrations-request-eyebrow": "Do not see your tool?",
  "integrations-request-heading": "Request another integration",
  "integrations-request-description": "Add the system your firm relies on, plus any context that helps us understand the workflow you want connected.",
  "integrations-request-form-label": "Integration request form",
  "integrations-request-input-label": "Integration name",
  "integrations-request-input-placeholder": "Example: Pontera, Nitrogen, Altruist, or the niche tool your operations team cannot live without.",
  "integrations-request-submit": "Send request",
  "integrations-request-submit-loading": "Sending...",
  "integrations-category-crm": "CRM",
  "integrations-category-advisor-crm": "Advisor CRM",
  "integrations-category-planning": "Planning",
  "integrations-category-meeting-ai": "Meeting AI",
  "integrations-category-portfolio": "Portfolio",
  "integrations-category-held-away-assets": "Held-away assets",
  "integrations-category-aggregation": "Aggregation",
  "integrations-category-automation": "Automation",
  "integrations-thumb-morningstar-baa-name": "Morningstar ByAllAccounts",
  "integrations-thumb-zapier-name": "Zapier",
  "integrations-thumb-salesforce-name": "Salesforce",
  "integrations-thumb-salesforce-description": "Sync household details, opportunities, and advisor activity from the CRM teams already live in.",
  "integrations-thumb-hubspot-name": "HubSpot",
  "integrations-thumb-hubspot-description": "Bring prospect and client engagement context into Elements without another spreadsheet export.",
  "integrations-thumb-wealthbox-name": "Wealthbox",
  "integrations-thumb-wealthbox-description": "Keep client records, tasks, and planning follow-ups aligned for relationship-first advisory teams.",
  "integrations-thumb-redtail-name": "Redtail CRM",
  "integrations-thumb-redtail-description": "Connect a familiar advisor CRM workflow to Elements client monitoring and review prep.",
  "integrations-thumb-rightcapital-name": "RightCapital",
  "integrations-thumb-rightcapital-description": "Make financial-plan context easier to reference while reviewing Elements scores and next steps.",
  "integrations-thumb-emoney-name": "eMoney",
  "integrations-thumb-emoney-description": "Give planning-heavy firms a cleaner bridge between planning assumptions and Elements workflows.",
  "integrations-thumb-jump-name": "Jump",
  "integrations-thumb-jump-description": "Turn meeting notes and advisor follow-ups into cleaner client action context inside Elements.",
  "integrations-thumb-orion-name": "Orion",
  "integrations-thumb-orion-description": "Help portfolio and account data travel into reviews without extra downloads or duplicate entry.",
  "integrations-thumb-black-diamond-name": "Black Diamond",
  "integrations-thumb-black-diamond-description": "Support performance-reporting teams that want Elements alongside existing portfolio systems.",
  "integrations-thumb-pontera-name": "Pontera",
  "integrations-thumb-pontera-description": "Surface held-away account context for advisors coordinating retirement account guidance.",

  "baa-integration-getting-started-link": "Getting Started",
  "baa-integration-user-guide-thumb-title": "Getting Started",
  "baa-integration-user-guide-thumb-description": "Open this step-by-step guide for help setting up the ByAllAccounts integration.",
  "baa-integration-meta-title": "Morningstar ByAllAccounts",
  "baa-integration-meta-description": "Elements's Morningstar ByAllAccounts integration",
  "baa-integration-thumb-title": "By All Accounts",
  "baa-integration-thumb-action-button": "View Details",
  "baa-integration-thumb-description": "Data aggregator for connecting your managed accounts to your clients in Elements.",

  "zapier-integration-thumb-title": "Zapier",
  "zapier-integration-thumb-action-button": "View Details",
  "zapier-integration-thumb-description": "Connect your Zapier account for seamless productivity and integration with Elements.",

  "coming-soon-integration-thumb-title": "Coming Soon…",
  "coming-soon-integration-thumb-action-button": "View Details",
  "coming-soon-integration-thumb-description": "More integrations are coming soon. Any recommendations? Let us know.",

  "suggest-integration-meta-title": "Suggest Integration",
  "suggest-integration-meta-description": "Suggest which services you'd like Elements to integrate with next",
  "suggest-integration-modal-title": "Suggest Integrations",
  "suggest-integration-modal-body": "We’d love to hear which services you’d like to see us integrate with next. Your input will help us with planning and priority.",
  "suggest-integration-modal-input-label": "Your Suggested Integrations",
  "suggest-integration-success-message": "Suggestion successfully submitted!",

  "baa-view-header-back-button": "Integrations",
  "baa-view-header-menu-user-guide": "Integration User Guide",
  "baa-view-header-menu-go-to-baa": "Go to By All Accounts",
  "baa-view-header-menu-change-credentials": "Edit Username/Password",
  "baa-view-header-menu-remove-integration": "Remove Integration",
  "baa-view-header-menu-show-all-firm-accounts": "Show All Firm Accounts",

  "baa-view-heading": "Morningstar® ByAllAccounts™",
  "baa-view-description": "Choose a client and select from your available connected accounts to link them to your clients.",

  "baa-view-client-households-table-header-title": "Client Households",
  "baa-view-client-households-table-search-placeholder": "Find by name",
  "baa-view-client-households-table-empty-text": "You have not added anyone to your client list.",
  "baa-view-client-households-table-select-client-banner": "Select a client to add those accounts to their net worth summary.",

  "baa-view-connected-accounts-table-search-placeholder": "Find by name or account number",
  "baa-view-connected-accounts-table-header-title": "Unassigned Accounts",
  "baa-view-connected-accounts-table-empty-text": "There are no available accounts.",
  "baa-view-connected-accounts-table-view-assigned-menu-option": "View Assigned Accounts",

  "baa-view-selected-client-card-back-button": "Back to Client Households",
  "baa-view-selected-client-card-action-button": "Continue...",
  "baa-view-selected-client-card-description": "Select from your available connected accounts to link them to your clients.",
  "baa-view-selected-client-card-accounts-linked-notification-others_one": "and one other account ",
  "baa-view-selected-client-card-accounts-linked-notification-others_other": "and {{count}} other accounts ",
  "baa-view-selected-client-card-accounts-linked-notification": "{{- names}} {{others}}successfully linked to {{- clientName}}.",

  "baa-request-access-view-header": "Morningstar® ByAllAccounts™",
  "baa-request-access-view-body": "The only financial data aggregator exclusively focused on the needs of investors, advisors, and the enterprises who support them.\n\nGet started by requesting access to ByAllAccounts™.",
  "baa-request-access-view-action-button": "Request Access",

  "baa-account-created-modal-title": "Account Created!",
  "baa-account-created-modal-description": "The next step is heading to ByAllAccounts, signing in, and authenticating with your custodian. Your username and temporary password are below.",
  "baa-account-created-modal-username": "Username",
  "baa-account-created-modal-temporary-password": "Temporary Password",
  "baa-account-created-modal-copy-password": "Copy Password",
  "baa-account-created-modal-main-action": "Go to ByAllAccounts",
  "baa-account-created-modal-feeling-stuck-title": "Feeling stuck?",
  "baa-account-created-modal-feeling-stuck-link": "Open Getting Started Guide",

  "baa-create-username-modal-title": "Create Your Username",
  "baa-create-username-modal-body": "Create your username and we’ll create your account and give you a temporary password.",
  "baa-create-username-action-button": "Continue",
  "baa-create-username-multi-firm-input-helper": "If you have access to multiple firms, you will need a unique username for each one",

  "baa-view-client-assigned-accounts-empty-text": "Viewing Assigned Accounts.\n\nSelect an assigned account to see which client it’s linked to.",
  "baa-view-client-assigned-accounts-table-header-title": "Client Households",

  "baa-view-remove-account-success-notification": "{{- accountName}} successfully unassigned  from {{- clientName}}",
  "baa-view-remove-account-modal-title": "Remove Assigned Account?",
  "baa-view-remove-account-modal-body": "Unassigning “{{- accountName}}” from {{- clientName}} will remove that account from their net worth summary.\n\nThis account will then become available to be mapped to another client in Elements.",
  "baa-view-remove-account-modal-ok-text": "Remove Assigned Account",

  "baa-view-assigned-accounts-table-view-assigned-menu-option": "View Unassigned Accounts",
  "baa-view-assigned-accounts-table-header-title": "Assigned Accounts",

  "baa-create-accounts-title": "Add Linked Accounts to Client",
  "baa-create-accounts-description": "Here’s your chance to merge with an account that already exists on the client’s Elements account. If no existing account is specified, we’ll create a new net worth item for your client. ",
  "baa-create-accounts-dropdown-option-new-account": "New Account",

  "baa-remove-integration-confirmation-modal-title": "Remove Integration?",
  "baa-remove-integration-confirmation-modal-body-text": "Removing this integration will permanently delete your ByAllAccounts account and convert all connected accounts from ByAllAccounts into manual accounts. Are you sure you want to remove this integration?",
  "baa-remove-integration-confirmation-modal-ok-text": "Remove ByAllAccounts ",

  "baa-accounts-page-skeleton-loading": "Loading...",
  "baa-accounts-page-skeleton-loading-slow": "Slow connection. Still loading...",

  "baa-account-monetary-list-item-advisor-subtitle": " (Advisor: <span>{{- givenName}}</span> <span>{{- familyName}}</span>)"
}
